/**
 * Module Vuex pour l'authentification
 * Gère l'état de l'utilisateur connecté
 */
import { authService } from '@/services';

const state = {
  user: null,
  token: null,
  isAuthenticated: false,
};

const getters = {
  currentUser: (state) => state.user,
  isAuthenticated: (state) => state.isAuthenticated,
  userRole: (state) => state.user?.roleCode || null,
  userCompany: (state) => state.user?.compagnieTransportRaisonSociale || null,
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
    state.isAuthenticated = !!user;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  CLEAR_AUTH(state) {
    state.user = null;
    state.token = null;
    state.isAuthenticated = false;
  },
};

const actions = {
  /**
   * Connexion utilisateur
   */
  async login({ commit }, credentials) {
    try {
      const response = await authService.login(credentials);
      commit('SET_USER', response.user);
      commit('SET_TOKEN', response.token);
      return response;
    } catch (error) {
      commit('CLEAR_AUTH');
      throw error;
    }
  },

  /**
   * Déconnexion utilisateur
   */
  logout({ commit }) {
    authService.logout();
    commit('CLEAR_AUTH');
  },

  /**
   * Rafraîchir le token
   */
  async refreshToken({ commit, state }) {
    try {
      const response = await authService.refreshToken(state.user.refreshToken);
      commit('SET_TOKEN', response.token);
      return response;
    } catch (error) {
      commit('CLEAR_AUTH');
      throw error;
    }
  },

  /**
   * Initialiser l'authentification depuis le localStorage
   */
  initAuth({ commit }) {
    const token = authService.getToken();
    if (token) {
      commit('SET_TOKEN', token);
      // Récupérer les infos utilisateur si nécessaire
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
